// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPaymentProcessorData } from './GetPaymentProcessorData';
import {
  GetPaymentProcessorDataFromJSON,
  GetPaymentProcessorDataFromJSONTyped,
  GetPaymentProcessorDataToJSON,
  GetPaymentProcessorDataToJSONTyped,
} from './GetPaymentProcessorData';

/**
 *
 * @export
 * @interface PaymentProcessor
 */
export interface PaymentProcessor {
  /**
   * Unique identifier of the payment processor.
   * @type {string}
   * @memberof PaymentProcessor
   */
  paymentProcessorID: string;
  /**
   * Payment processor type (e.g., Stripe).
   * @type {string}
   * @memberof PaymentProcessor
   */
  type: string;
  /**
   * Payment processor state (e.g., settled, delinquent).
   * @type {string}
   * @memberof PaymentProcessor
   */
  state: string;
  /**
   *
   * @type {GetPaymentProcessorData}
   * @memberof PaymentProcessor
   */
  data?: GetPaymentProcessorData;
}

/**
 * Check if a given object implements the PaymentProcessor interface.
 */
export function instanceOfPaymentProcessor(
  value: object,
): value is PaymentProcessor {
  if (
    !('paymentProcessorID' in value) ||
    value['paymentProcessorID'] === undefined
  )
    return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  if (!('state' in value) || value['state'] === undefined) return false;
  return true;
}

export function PaymentProcessorFromJSON(json: any): PaymentProcessor {
  return PaymentProcessorFromJSONTyped(json, false);
}

export function PaymentProcessorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaymentProcessor {
  if (json == null) {
    return json;
  }
  return {
    paymentProcessorID: json['paymentProcessorID'],
    type: json['type'],
    state: json['state'],
    data:
      json['data'] == null
        ? undefined
        : GetPaymentProcessorDataFromJSON(json['data']),
  };
}

export function PaymentProcessorToJSON(json: any): PaymentProcessor {
  return PaymentProcessorToJSONTyped(json, false);
}

export function PaymentProcessorToJSONTyped(
  value?: PaymentProcessor | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    paymentProcessorID: value['paymentProcessorID'],
    type: value['type'],
    state: value['state'],
    data: GetPaymentProcessorDataToJSON(value['data']),
  };
}
